import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/wineapp-logo.png';
import './AppHeader.css';

const AppHeader = () => {
  return (
    <header className="app-header">
      <div className="header-content">
        <Link to="/welcome" className="logo-link">
          <img src={logo} alt="WineApp Logo" className="app-logo" />
          <span className="app-title">WineApp</span>
        </Link>
        <nav className="header-nav">
          <Link to="/about" className="nav-link">About</Link>
        </nav>
      </div>
    </header>
  );
};

export default AppHeader;
